import React, { Component } from 'react';
import PrintProductionLabels from './PrintProductionLabels';
import LabelProductionList from './LabelProductionList';

export default class ProductionLabelList extends Component {
  render() {
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <span><i className="fa fa-edit mr-05"></i><span>{this.props.title}</span></span>
              <button type="button" className="btn btn-primary m-0" onClick={()=>{this.props.printAll(this.props.sessionOutput, this.props.intermediateLabels)}}>
                {this.props.printListMessage ||'Print All'}
              </button>
            </div>
            <div className="card-block p-0">
              <table className="table table-striped table-bordered datatable mb-0">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th className="hidden-xs-down">Session Id</th>
                    <th className="hidden-sm-down">Vendor</th>
                    <th className="hidden-sm-down">Brand</th>
                    <th className="hidden-md-down">Packing Date</th>
                    <th className="hidden-md-down">Expiration Date</th>
                    <th>Item</th>
                    <th className="hidden-sm-down">Qty</th>
                    <th className="hidden-sm-down">Count</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <LabelProductionList
                  output={this.props.sessionOutput}
                  session={this.props.sessionId}
                  printLabel={this.props.printLabel}
                  alreadyPrinted={this.props.intermediateLabels}/>
              </table>
            </div>
          </div>
        </div>
        {
          this.props.sessionOutput.map((output,index)=>{
          return (
            <div id={index} key={index}>
              <PrintProductionLabels
                session={this.props.sessionId}
                output={output}
                index={index}
                printLabel={this.props.printLabel}
                alreadyPrinted={this.props.intermediateLabels}/>
            </div>
          )
        })
      }
      </div>
    );
  }
}
